<template>
	<v-dialog v-model="dialog.display" max-width="260" persistent>
		<v-card>
			<v-card-text class="d-flex justify-center">
				<ChromePicker 
					v-bind:value="dialog.colors"
					v-if="display"
					ref="color"
				></ChromePicker>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat="flat" @click="onClickCancel" >取消</v-btn>
				<v-btn color="green darken-1" flat="flat" @click="onClickDone">決定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import VueColor from 'vue-color';

const chrome = VueColor.Chrome;

export default {
	name: 'GBDialogColorPicker',
	props: [
		"dialog",
	],
	components: {
		ChromePicker: chrome,
	},
	methods: {
		onClickDone: function() {
			this.$emit('update', this.$refs.color.colors.rgba);
		},
		onClickCancel: function() {
			this.$emit('cancel');
		},
	},
	computed: {
		display: function() {
			return this.dialog.display;
		},
	},
};
</script>
